import React, { useState, useEffect, useContext } from "react";
import { Link, useLoaderData, useParams } from "react-router-dom";
import instance from "../../services/ApiServices";
import { motion } from "motion/react";
import ProductCart from "./ProductCart";

const FoodMenu = () => {
  const Menucategory = useLoaderData();
  const isEven = (num) => num % 2 === 0;
  // const params = useParams();
  // const enquiredevent=params.eventId
  // const endpoint = "search-menucategory/food";
  // const [Menucategory, setMenucategory] = useState([]);
  useEffect(() => {}, []);

  return (
    <div className="container pb-10">
      <h1 className="text-4xl lg:text-6xl font-semibold pt-10">Food Menu</h1>

      {Menucategory.map((menu, index) => (
        <div
          className="sm:flex flex-row my-5 mb-20 bg-slate-100"
          key={index}
        >
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            viewport={{ once: true }}
            whileInView={{
              x: 0,
              opacity: 1,
              transition: {
                delay: 0.5,
                x: { type: "spring", stiffness: 60 },
                opacity: { duration: 0.6 },
                ease: "easeIn",
              },
            }}
            className="justify-center
    items-center
    overflow-hidden"
          >
            <img
              className="object-cover w-full"
              src={menu.image}
              alt=""
            />
          </motion.div>
        </div>
      ))}
    </div>
  );
};

export async function loader() {
  const endpoint = "search-menucategory/food";
  const response = await instance.get(endpoint);
  return response.data;
}

export default FoodMenu;
